import { Controller } from "@hotwired/stimulus"
import SlimSelect from 'slim-select'

export default class extends Controller {
    static values = { placeholder: String }

    connect() {
        this.slim = new SlimSelect({
            select: this.element,
            settings: {
                placeholderText: this.placeholderValue,
            }
        })
    }

    disconnect() {
        if (this.slim) {
            this.slim.destroy()
        }
    }
}